import { Controller } from '@hotwired/stimulus'
import QRCode from 'qrcode'

export default class extends Controller {
    static values = { uri: String }

    connect() {
        QRCode.toString(this.uriValue, {
            type: 'svg',
            errorCorrectionLevel: 'M',
            margin: 2,
            color: { dark: '#373737', light: '#FFFFFF' },
            width: 200,
        })
            .then((svg) => {
                this.element.innerHTML = svg
            })
            .catch(() => {})
    }
}
